import Button from "../../../../shared/components/lib/Button";
import ChevronUpDown from "@geist-ui/react-icons/chevronUpDown";
import { useAtom } from "jotai";
import { uploadFilesAtom, uploadModalOpenAtom } from "./MediaUploadModal";

const MediaUploadToast = () => {
  const [open, setOpen] = useAtom(uploadModalOpenAtom);
  const [files, setFiles] = useAtom(uploadFilesAtom);

  return (
    <div
      id="media-upload-toast"
      className={` transition-opacity duration-200 ${
        !open && files.length > 0
          ? "visible opacity-100"
          : "invisible opacity-0"
      }`}
    >
      {!open && files.length > 0 && (
        <div
          className="fixed px-4 py-3 shadow-sm rounded-md bg-white z-modal"
          style={{ width: "20rem", maxWidth: "95%", bottom: 24, right: 24 }}
        >
          <div className="flex items-center justify-between">
            <p className="text-sm">
              {files.length}{" "}
              {files.length === 1 ? "Element wird " : "Elemente werden"}
              hochgeladen.
            </p>
            <div className="flex items-center">
              <p className="text-sm text-foreground-soft mr-1">2 Min.</p>
              <Button
                onClick={() => setOpen(true)}
                iconButton
                icon={<ChevronUpDown />}
                size="small"
                type="abort"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default MediaUploadToast;
